import Vue from 'vue'
import features from '~/config/features.cjs'

Vue.mixin({
  computed: {
    paymentsEnabled () {
      return features.payments
    }
  }
})
